import {
  setLoadingConfigObject,
  shimmerPlaceholderConfig,
} from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import styles from './AddOnsShopLoading.Config.Styles';

const tabsLoadingConfig = [
  {
    main: [
      'row',
      setLoadingConfigObject('square', 1, null, styles.tabItemStyle(true)),
      setLoadingConfigObject('square', 1, null, styles.tabItemStyle()),
      setLoadingConfigObject('square', 1, null, styles.tabItemStyle()),
      setLoadingConfigObject('square', 1, null, styles.tabItemStyle()),
      setLoadingConfigObject('square', 1, null, styles.tabItemStyle()),
    ],
    containerStyle: styles.tabsContainerStyle,
  },
];

const cardLoadingConfig = [
  {
    containerStyle: styles.cardBodyItemContainer,
    left: setLoadingConfigObject('circle', 1, null, styles.cardBodyItemCircle),
    main: setLoadingConfigObject('square', 2, null, styles.cardBodyItemSquare),
  },
];

const separatorLoadingConfig = theme => [
  {
    style: styles.separator(theme),
  },
];

const titlesLoadingConfig = [
  { left: setLoadingConfigObject('square', 1, null, styles.title) },
  { left: setLoadingConfigObject('square', 1, null, styles.subtitle) },
];

export {
  tabsLoadingConfig,
  cardLoadingConfig,
  separatorLoadingConfig,
  titlesLoadingConfig,
  shimmerPlaceholderConfig,
};
